/**
 * TODO: when update <Tag /> to the newest version, unify this component
 * with Tag
 */
import PropTypes from 'prop-types';
import { cloneElement } from 'react';

import Text from 'shopper/components/Text';

const HIGHLIGHT_COLOR_BY_TYPE = {
  primary: 'text-primary-400 dark:text-primary-400',
  secondary: 'text-secondary-400 dark:text-secondary-400',
};

const Tag = ({ type, iconLeft, children }) => (
  <div className="flex w-fit items-center gap-x-2 rounded-5 bg-neutral-high-100 p-2">
    {cloneElement(iconLeft, {
      className: HIGHLIGHT_COLOR_BY_TYPE[type],
      size: 'size1',
    })}
    <Text className={HIGHLIGHT_COLOR_BY_TYPE[type]} size="size2">
      {children}
    </Text>
  </div>
);

Tag.propTypes = {
  type: PropTypes.string.isRequired,
  iconLeft: PropTypes.node.isRequired,
  children: PropTypes.string.isRequired,
};

export default Tag;
